import {useState} from "react";
import {useAuthsState} from "../auths/authsContext";
import {kitFetch} from "@ekultur/fetch";
import useDeepCompareEffect from "use-deep-compare-effect";
import {clientLog} from "../clientLog";

export const useMyMuseumsState = ({onlyAdministrativeMuseums = false}) => {
    const {userData} = useAuthsState();
    const [museums, setMuseums] = useState([]);
    const [loading, setLoading] = useState(!!userData['appAccess']);

    const findDamsApp = (application) =>
        application.id === window._env_.REACT_APP_ID &&
        (!onlyAdministrativeMuseums || application.role.name === "Admin");

    useDeepCompareEffect(() => {
        if (userData['appAccess']) {
            const myMuseumIds = userData['appAccess'].museums
                .filter((museum) => museum.applications.find(findDamsApp))
                .map((museum) => museum.id);

            setLoading(true);
            kitFetch(`/museum-api/museums?fields[]=id,name,ekultur_id,profile`)
                .then((json) => {
                    setMuseums(
                        json['museums'].filter((museum) => myMuseumIds.includes(museum.id))
                    );
                    setLoading(false);
                })
                .catch((error) => {
                    clientLog('error', error, 'useMyMuseums');
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [JSON.stringify(userData), setMuseums]);

    return {museums, loading};
};

export const useMyMuseums = (options) => useMyMuseumsState(options).museums;
